import EmployeeDashboardSwitch from './EmployeeDashboardSwitch';
export default EmployeeDashboardSwitch;
